import React from "react";

import { SonicTermData } from "../../../common/classes/SonicTerm";
import ActionBtn from "../../../common/management/ActionBtn";

import {
  genStatusColor,
  genStatusText,
  timestampToTime,
} from "../../../utils/GeneralUtils";

import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  id: string;
  name: string;
  category: SonicTermData;
  ownerName: string;
  start_date: number;
  end_date?: number;
  status: string;
  isSelect: boolean;
};

const EventListItem: React.FC<Props> = ({
  name,
  id,
  category,
  ownerName,
  start_date,
  end_date,
  status,
  isSelect,
}) => {
  return (
    <div
      className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["event"]}`}
    >
      <div>{name}</div>
      <div>{category?.name}</div>
      <div>{ownerName}</div>
      <div>
        {timestampToTime(start_date, false)} <br />
        {end_date ? `- ${timestampToTime(end_date, false)}` : null}
      </div>
      <div>
        <span
          className={styles["status"]}
          style={{ backgroundColor: genStatusColor(status, end_date) }}
        >
          {genStatusText(status, undefined, end_date)}
        </span>
      </div>
      <div className={styles["f-dbList__category-action"]}>
        <ActionBtn
          label="詳細"
          icon={["fal", "edit"]}
          link={isSelect ? `/admin/event/${id}` : `/jikei/event/${id}`}
        />
      </div>
    </div>
  );
};

export default EventListItem;
